import { render, staticRenderFns } from "./thesis.vue?vue&type=template&id=3b252ec1&scoped=true&"
import script from "./thesis.vue?vue&type=script&lang=js&"
export * from "./thesis.vue?vue&type=script&lang=js&"
import style0 from "./thesis.vue?vue&type=style&index=0&id=3b252ec1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b252ec1",
  null
  
)

export default component.exports